import React from "react";
import { oneOfType, arrayOf, node, string, func } from "prop-types";

import { CloseIcon } from "../../basic/icons/close-icon";

import "./topArrowContainer.m.css";

const TopArrowContainer = ({ children, closeView, className = "" }) => (
  <div styleName="top-arrow-container" className={className}>
    <div styleName="close-wrapper" className="remove-wrapper">
      <div styleName="close-icon" onClick={closeView}>
        <CloseIcon width={30} height={30} color="#555555" />
      </div>
    </div>
    <ul role="dropdown" styleName="list-portion">
      {children}
    </ul>
  </div>
);

TopArrowContainer.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
  className: string,
  closeView: func,
};

export default TopArrowContainer;
